const NameStorageKey = "ROSTER_NAME";
const RefreshStorageKey = "REFRESH_KEY";
export const storeName = async (name: string): Promise<void> => {
  localStorage.setItem(NameStorageKey, name);
  return Promise.resolve();
};

export const loadName = async (): Promise<string> => {
  const name = localStorage.getItem(NameStorageKey) || "";
  return Promise.resolve(name);
};

export const storeRefreshValue = async (value: string): Promise<void> => {
  localStorage.setItem(RefreshStorageKey, value);
  return Promise.resolve();
};

export const loadRefreshValue = async (): Promise<string> => {
  const refreshed = localStorage.getItem(RefreshStorageKey) || "";
  return Promise.resolve(refreshed);
};
